import Vue from "vue";
import Vuex from "vuex";
import { getters, actions } from "./global"
import modules from "./modules"
import state from './state'
import mutations from './mutations'
import VueTextareaAutosize from 'vue-textarea-autosize'

Vue.use(VueTextareaAutosize)

Vue.use(Vuex);

export default new Vuex.Store({
  modules: modules,
  state,
  getters,
  mutations,
  actions
});
